import styled from 'styled-components'

import { themeStyles } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'
import Link from '../../atoms/link'

const gap = '0.25em'
const iconSize = '2em'
const slideSize = '5em'

export const StyledHorizontalScrollWrapper = styled.div`
  overflow-x: auto;
  max-width: 100%;
`

export const StyledMobilePMWrapper = styled.div`
  display: flex;
  position: relative;
  background-color: ${themeStyles.colors.darkGreys[4].main};
  border-radius: 8px;
  padding: 8px 0;

  gap: ${gap};
  width: max(
    100%,
    ${(props) =>
      props.length * parseInt(slideSize) + (props.length - 1) * parseInt(gap)}em
  );
`

export const StyledChild = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-decoration: none;

  overflow: hidden;
  padding: 0;

  color: ${themeStyles.colors.white.main};
  background-color: transparent;

  > * {
    height: 50%;
    width: 100%;
    margin: 0;
  }
`

export const StyledIcon = styled.img`
  width: ${iconSize};
  height: ${iconSize};
  object-fit: cover;
  padding: 0.25em;
`

export const StyledText = styled.p`
  display: flex;

  font-weight: ${brandConfig.fonts.text.paragraph.weight};
  font-size: ${brandConfig.fonts.text.small.size.mobile};
  height: 2.5em;
  align-items: center;
  justify-content: center;
  text-align: center;
`
